import { Switch } from "@headlessui/react";

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

export const Toggle = (props: any) => (
  <Switch
    checked={props.onoff}
    onChange={() => props.onChange()}
    className={classNames(
      props.onoff ? "bg-dustyrose" : "bg-gray-200",
      "relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-dustyrose"
    )}
  >
    <span
      aria-hidden="true"
      className={classNames(
        props.onoff ? "translate-x-5" : "translate-x-0",
        "pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"
      )}
    />
  </Switch>
);
